export default __webpack_public_path__ + "static/media/Bathroom.c118f234.jpeg";